import React from 'react';
import propTypes from 'prop-types';

const CleanButton = (props) => {

    const styles = props.styles != null ?
        Object.assign({}, {cursor: props.disabled ? 'not-allowed' : 'pointer'}, props.styles) :
        {cursor: props.disabled ? 'not-allowed' : 'pointer'};

    return (
        <button type="button"
                className={props.classes}
                onClick={props.cleanField}
                style={styles}
                disabled={props.disabled ? props.disabled : false}>
            {props.children ? props.children : null}
            <span className={props.children ? 'ml-2' : null}>Pulisci</span>
        </button>)
};

CleanButton.propTypes = {
    classes: propTypes.string.isRequired,
    cleanField: propTypes.func.isRequired,
    styles: propTypes.object
};

export default CleanButton;


